<div class="theme-container">
<mat-card fxLayout="row wrap" fxLayoutAlign="space-around">
    <div fxFlex="100" fxFlex.gt-xs="33.3">
        <div fxLayout="column" fxLayoutAlign="center center" class="text-center">
            <mat-icon color="primary" class="mat-icon-lg">home</mat-icon>
            <h3 class="primary-text py-1">{{'TOBA LIGHT.user.form.address' | translate }} :</h3>
            <span class="text-muted">2903 Avenue Z, Brooklyn, New York City</span>
        </div>
    </div>
    <div fxFlex="100" fxFlex.gt-xs="33.3" ngClass.xs="mt-2">
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-icon color="primary" class="mat-icon-lg">call</mat-icon>
            <h3 class="primary-text py-1">{{'TOBA LIGHT.user.form.phone' | translate }}:</h3>
            <span class="text-muted">(212) 457-2308</span>
            <span class="text-muted">(212) 457-2309</span>
        </div>
    </div>
    <div fxFlex="100" fxFlex.gt-xs="33.3" ngClass.xs="mt-2">
        <div fxLayout="column" fxLayoutAlign="center center">
            <mat-icon color="primary" class="mat-icon-lg">mail_outline</mat-icon>
            <h3 class="primary-text py-1">{{'TOBA LIGHT.user.form.email' | translate }} :</h3>
            <span class="text-muted">contact@emporium.com</span>
            <span class="text-muted">info@emporium.com</span>
        </div>
    </div>
    <div class="divider w-100 mt-2"></div>
    <h3 class="w-100 text-center py-2">{{'TOBA LIGHT.user.label.Contacts' | translate }}</h3>
    
    <form [formGroup]="contactForm" (ngSubmit)="onContactFormSubmit(contactForm.value)" fxLayout="row wrap">
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
          <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'TOBA LIGHT.label.name' | translate }}</mat-label>
                <input matInput placeholder="Name" formControlName="name" required>
                <mat-error *ngIf="contactForm.controls.name.errors?.required">{{'TOBA LIGHT.label.Required' | translate }}</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
          <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'TOBA LIGHT.user.form.email' | translate }}</mat-label>
                <input matInput placeholder="Email" formControlName="email" required>
                <mat-error *ngIf="contactForm.controls.email.errors?.required">{{'TOBA LIGHT.label.Required' | translate }}</mat-error>
                <mat-error *ngIf="contactForm.controls.email.hasError('invalidEmail')">Invalid email address</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33.3" class="px-1" ngClass.sm="mt-1" ngClass.xs="mt-1">
          <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'TOBA LIGHT.user.form.phone' | translate }}</mat-label>
                <input matInput placeholder="Phone" formControlName="phone" required type="number">
                <mat-error *ngIf="contactForm.controls.phone.errors?.required"> {{'TOBA LIGHT.label.Required' | translate }}</mat-error>
          </mat-form-field>
        </div>
        <div fxFlex="100" class="px-1 mt-1">
          <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{'TOBA LIGHT.user.Message' | translate }}</mat-label>
                <textarea matInput placeholder="Message" formControlName="message" required rows="7"></textarea> 
                <mat-error *ngIf="contactForm.controls.message.errors?.required">{{'TOBA LIGHT.user.MessageIsRequired' | translate }}</mat-error>
          </mat-form-field>
        </div> 
        <div class="w-100 py-2 text-center">
          <button mat-raised-button color="primary" type="submit">{{'TOBA LIGHT.label.submit' | translate }}</button>
        </div> 
    </form>

</mat-card>
</div>
